<div class="color-palette-management">
	<div class="modal-header">
		<h4 class="modal-title">Värien hallinta</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="close()"
		></button>
	</div>

	<div class="modal-body">
		<!-- All Games Palettes -->
		<div class="palette-category" *ngIf="hasPalettes('all')">
			<h5 class="category-title">Kaikki pelit</h5>
			<div class="palette-grid">
				<div
					class="palette-item position-relative"
					*ngFor="
						let palette of allGamesPalettes;
						trackBy: trackByPaletteId
					"
				>
					<div
						class="position-absolute top-0 end-0 m-1 d-flex gap-1"
						style="z-index: 1"
					>
						<button
							type="button"
							class="btn btn-light btn-sm"
							style="padding: 0.15rem 0.3rem"
							(click)="editPalette(palette)"
							title="Muokkaa"
						>
							<i
								class="bi bi-pencil"
								style="font-size: 0.7rem"
							></i>
						</button>
						<button
							type="button"
							class="btn btn-light btn-sm"
							style="padding: 0.15rem 0.3rem"
							(click)="confirmDeletePalette(palette, deletePaletteModal)"
							title="Poista"
						>
							<i
								class="bi bi-trash"
								style="font-size: 0.7rem"
							></i>
						</button>
					</div>
					<app-color-palette-preview
						[palette]="palette"
						[size]="'medium'"
						[displayMode]="'compact'"
						[showName]="true"
					>
					</app-color-palette-preview>
					<div
						class="palette-game-names mt-2"
						*ngIf="getGameNamesForPalette(palette).length > 0"
					>
						<small class="text-muted">
							<i class="bi bi-controller me-1"></i>
							{{ getGameNamesForPalette(palette).join(', ') }}
						</small>
					</div>
				</div>
			</div>
		</div>

		<!-- Game Specific Palettes -->
		<div class="palette-category" *ngIf="hasPalettes('game')">
			<h5 class="category-title">Pelikohtainen</h5>
			<div class="palette-grid">
				<div
					class="palette-item position-relative"
					*ngFor="
						let palette of gameSpecificPalettes;
						trackBy: trackByPaletteId
					"
				>
					<div
						class="position-absolute top-0 end-0 m-1 d-flex gap-1"
						style="z-index: 1"
					>
						<button
							type="button"
							class="btn btn-light btn-sm"
							style="padding: 0.15rem 0.3rem"
							(click)="editPalette(palette)"
							title="Muokkaa"
						>
							<i
								class="bi bi-pencil"
								style="font-size: 0.7rem"
							></i>
						</button>
						<button
							type="button"
							class="btn btn-light btn-sm"
							style="padding: 0.15rem 0.3rem"
							(click)="confirmDeletePalette(palette, deletePaletteModal)"
							title="Poista"
						>
							<i
								class="bi bi-trash"
								style="font-size: 0.7rem"
							></i>
						</button>
					</div>
					<app-color-palette-preview
						[palette]="palette"
						[size]="'medium'"
						[displayMode]="'compact'"
						[showName]="true"
					>
					</app-color-palette-preview>
					<div
						class="palette-game-names mt-2"
						*ngIf="getGameNamesForPalette(palette).length > 0"
					>
						<small class="text-muted">
							<i class="bi bi-controller me-1"></i>
							{{ getGameNamesForPalette(palette).join(', ') }}
						</small>
					</div>
				</div>
			</div>
		</div>

		<!-- Interface Specific Palettes -->
		<div class="palette-category" *ngIf="hasPalettes('interface')">
			<h5 class="category-title">Ulkoasukohtainen</h5>
			<div class="palette-grid">
				<div
					class="palette-item position-relative"
					*ngFor="
						let palette of interfaceSpecificPalettes;
						trackBy: trackByPaletteId
					"
				>
					<div
						class="position-absolute top-0 end-0 m-1 d-flex gap-1"
						style="z-index: 1"
					>
						<button
							type="button"
							class="btn btn-light btn-sm"
							style="padding: 0.15rem 0.3rem"
							(click)="editPalette(palette)"
							title="Muokkaa"
						>
							<i
								class="bi bi-pencil"
								style="font-size: 0.7rem"
							></i>
						</button>
						<button
							type="button"
							class="btn btn-light btn-sm"
							style="padding: 0.15rem 0.3rem"
							(click)="confirmDeletePalette(palette, deletePaletteModal)"
							title="Poista"
						>
							<i
								class="bi bi-trash"
								style="font-size: 0.7rem"
							></i>
						</button>
					</div>
					<app-color-palette-preview
						[palette]="palette"
						[size]="'medium'"
						[displayMode]="'compact'"
						[showName]="true"
					>
					</app-color-palette-preview>
					<div
						class="palette-game-names mt-2"
						*ngIf="getGameNamesForPalette(palette).length > 0"
					>
						<small class="text-muted">
							<i class="bi bi-controller me-1"></i>
							{{ getGameNamesForPalette(palette).join(', ') }}
						</small>
					</div>
				</div>
			</div>
		</div>

		<!-- No palettes message -->
		<div
			class="no-palettes-message"
			*ngIf="
				!hasPalettes('all') &&
				!hasPalettes('game') &&
				!hasPalettes('interface')
			"
		>
			<p class="text-muted text-center py-4">
				Ei tallennettuja väripaletteja. Luo uusi paletti
				pelimuokkaimessa.
			</p>
		</div>
	</div>
</div>

<!-- Edit Palette Modal -->
<ng-template #editPaletteModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">
			Muokkaa palettia: {{ editingPalette?.name }}
		</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="cancelEdit()"
		></button>
	</div>

	<div class="modal-body">
		<div *ngIf="editingPalette" class="edit-palette-container">
			<div class="row">
				<!-- Left Column: Name and Visibility -->
				<div class="col-12 col-lg-3 mb-3">
					<!-- Palette Name Input -->
					<div class="mb-4">
						<label for="paletteName" class="form-label fw-bold"
							>Paletin nimi</label
						>
						<input
							type="text"
							class="form-control"
							id="paletteName"
							[(ngModel)]="editingPalette.name"
							placeholder="Anna paletin nimi"
						/>
					</div>

					<!-- Visibility Button Group -->
					<div class="mb-4">
						<label class="form-label fw-bold d-block mb-2"
							>Näkyvyys</label
						>
						<div
							class="btn-group-vertical d-flex flex-column w-100"
							role="group"
							aria-label="Visibility selection"
						>
							<input
								type="radio"
								class="btn-check"
								name="paletteVisibility"
								id="visibility-interface"
								autocomplete="off"
								[(ngModel)]="editingPaletteVisibility"
								value="interface"
							/>
							<label
								class="btn btn-outline-primary"
								for="visibility-interface"
							>
								Yksi ulkoasu
							</label>

							<input
								type="radio"
								class="btn-check"
								name="paletteVisibility"
								id="visibility-game"
								autocomplete="off"
								[(ngModel)]="editingPaletteVisibility"
								value="game"
							/>
							<label
								class="btn btn-outline-primary"
								for="visibility-game"
							>
								Valitut pelit
							</label>

							<input
								type="radio"
								class="btn-check"
								name="paletteVisibility"
								id="visibility-all"
								autocomplete="off"
								[(ngModel)]="editingPaletteVisibility"
								value="all"
							/>
							<label
								class="btn btn-outline-primary"
								for="visibility-all"
							>
								Kaikki pelit
							</label>
						</div>
						<div class="form-text mt-2">
							<small class="text-muted">
								<i class="bi bi-info-circle me-1"></i>
								Valitse missä tämä väripaletti näkyy
							</small>
						</div>
					</div>
				</div>

				<!-- Color Editor -->
				<div class="col-12 col-lg-9">
					<app-color-palette-editor
						[palette]="editingPalette"
						[mode]="'offcanvas'"
						[readonly]="false"
						[hideHeader]="true"
						(paletteChange)="onPaletteChange($event)"
					>
					</app-color-palette-editor>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<!-- Plugin Type Pills (shown for 'game' visibility) -->
					<div class="mb-4" *ngIf="shouldShowPluginTypeSelector()">
						<label class="form-label fw-bold d-block mb-2">
							Pelit (valitse useita)
						</label>
						<div class="d-flex flex-wrap gap-2">
							<button
								*ngFor="let pt of availablePluginTypes"
								type="button"
								class="btn btn-sm rounded-pill"
								[class.btn-primary]="
									isPluginTypeSelected(pt.type)
								"
								[class.btn-outline-secondary]="
									!isPluginTypeSelected(pt.type)
								"
								(click)="togglePluginType(pt.type)"
							>
								{{ pt.title }}
							</button>
						</div>
						<div class="form-text mt-2">
							<small class="text-muted">
								<i class="bi bi-info-circle me-1"></i>
								Valitse pelit, joissa tämä paletti näkyy
							</small>
						</div>
					</div>

					<!-- Interface Info (shown for 'interface' visibility) -->
					<div class="mb-4" *ngIf="shouldShowInterfaceInfo()">
						<label class="form-label fw-bold d-block mb-2"
							>Peli ja ulkoasu</label
						>
						<div class="alert alert-info mb-0">
							<div>
								<strong>Peli:</strong>
								{{ getGameInfoForInterface().gameName }}
							</div>
							<div>
								<strong>Ulkoasu:</strong>
								{{ getGameInfoForInterface().interfaceName }}
							</div>
						</div>
						<div class="form-text mt-2">
							<small class="text-muted">
								<i class="bi bi-info-circle me-1"></i>
								Tämä paletti on sidottu tiettyyn peliin ja
								ulkoasuun. Peliä ja ulkoasua ei voi muuttaa.
							</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-outline-secondary"
			(click)="cancelEdit()"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-primary"
			(click)="saveEditedPalette()"
		>
			<i class="bi bi-floppy me-1"></i>
			Tallenna
		</button>
	</div>
</ng-template>

<!-- Delete Palette Confirmation Modal -->
<ng-template #deletePaletteModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Poista väripaletti</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss()"
		></button>
	</div>

	<div class="modal-body">
		<p>
			Oletko varma, että haluat poistaa väripaletin
			<strong>{{ paletteToDelete?.name }}</strong>?
		</p>
		<p class="text-muted mb-0">Tätä toimintoa ei voi perua.</p>
	</div>

	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss()"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-danger"
			(click)="modal.close('confirm')"
		>
			<i class="bi bi-trash me-1"></i>
			Poista
		</button>
	</div>
</ng-template>
